/**
 * Builds the shared grouped-control CSS classes for a consumer.
 *
 * Returns an empty list when the control is not in a group (falsy `position`),
 * otherwise the `grouped` base class plus the position/direction modifier.
 * Spread the result into `clsx(...)` at the call site.
 */
export function getGroupedControlClassNames(styles, { position, direction }) {
    if (!position) {
        return [];
    }
    return [styles.grouped, styles[`grouped-${direction}-${position}`]];
}
//# sourceMappingURL=grouped-control-styles.js.map